"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var styled_1 = __importDefault(require("@emotion/styled"));

var gatsby_link_1 = __importDefault(require("gatsby-link"));

var frontend_typography_1 = require("@ryerson/frontend.typography");

var polished_1 = require("polished");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var Link = function Link(_ref) {
  var to = _ref.to,
      color = _ref.color,
      className = _ref.className,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "primary" : _ref$type,
      size = _ref.size,
      _ref$gatsby = _ref.gatsby,
      gatsby = _ref$gatsby === void 0 ? true : _ref$gatsby,
      weight = _ref.weight,
      disabled = _ref.disabled,
      _ref$target = _ref.target,
      target = _ref$target === void 0 ? "_self" : _ref$target,
      underline = _ref.underline,
      italic = _ref.italic,
      animated = _ref.animated,
      dataTestId = _ref.dataTestId,
      componentRef = _ref.componentRef,
      children = _ref.children,
      breakPoint = _ref.breakPoint,
      _ref$autoResize = _ref.autoResize,
      autoResize = _ref$autoResize === void 0 ? true : _ref$autoResize,
      _ref$trusted = _ref.trusted,
      trusted = _ref$trusted === void 0 ? false : _ref$trusted;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _theme$colors$primary = theme.colors.primary,
      white = _theme$colors$primary.white,
      darkGray = _theme$colors$primary.darkGray;
  var currentColor = color || theme.colors[type].link;
  var hoverColor = (0, polished_1.mix)(0.65, currentColor, currentColor === white ? darkGray : white);
  var commonStyle = "\n        text-decoration: none;\n        color: ".concat(disabled ? theme.colors[type].disable : currentColor, ";\n        cursor:pointer; \n    ");
  var LinkRoot = styled_1.default.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\t", "\n\t\ta {\n\t\t\t", "\n\t\t}\n\t"])), disabled && "cursor:inherit;", disabled && "pointer-events:none;");
  var A = styled_1.default.a(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        ", "\n        ", "\n        ", "  \n    "])), commonStyle, disabled && "cursor:inherit;", !disabled && ":hover { color:".concat(hoverColor, ";}"));
  var Link = (0, styled_1.default)(gatsby_link_1.default)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        ", " \n        ", "\n        ", " \n\t\t"])), commonStyle, disabled && "cursor:inherit;", !disabled && ":hover { color:".concat(hoverColor, ";}"));

  function scrollToSection(e) {
    var _a;

    e.preventDefault();

    if (window && typeof window !== "undefined") {
      var hash = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.getAttribute("href");

      if (hash) {
        var section = document.getElementById(hash.replace("#", ""));

        if ((window === null || window === void 0 ? void 0 : window.innerWidth) >= parseInt(theme.breakpoints.lg)) {
          if (section) {
            var viewportTop = window.scrollY;
            var stickyHeader = document.getElementsByClassName("sticky")[0];
            var elementPosition = section.getBoundingClientRect().top + viewportTop;
            var headerHeight = stickyHeader !== undefined ? 120 : 140;
            var scrollToPosition = elementPosition - headerHeight;
            window === null || window === void 0 ? void 0 : window.scrollTo({
              top: scrollToPosition,
              behavior: "smooth"
            });
          }
        } else {
          if (section) {
            var _viewportTop = window.scrollY;

            var _elementPosition = section.getBoundingClientRect().top + _viewportTop;

            var _headerHeight = 10;

            var _scrollToPosition = _elementPosition - _headerHeight;

            window === null || window === void 0 ? void 0 : window.scrollTo({
              top: _scrollToPosition,
              behavior: "smooth"
            });
          }
        }

        history.pushState("", "", hash);
      }
    }
  }

  return (0, jsx_runtime_1.jsx)(LinkRoot, {
    "data-testid": dataTestId,
    className: "link-component-root ".concat(className || ""),
    children: typeof to === "string" ? (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
      type: type,
      size: size,
      weight: weight,
      underline: underline,
      italic: italic,
      breakPoint: breakPoint,
      autoResize: autoResize,
      children: [!gatsby && !animated && !trusted && (0, jsx_runtime_1.jsx)(A, {
        href: to,
        ref: componentRef,
        target: target,
        rel: "noopener noreferrer",
        children: children
      }), !gatsby && !animated && trusted && (0, jsx_runtime_1.jsx)(A, {
        href: to,
        ref: componentRef,
        target: target,
        children: children
      }), gatsby && !animated && (0, jsx_runtime_1.jsx)(Link, {
        to: to,
        ref: componentRef,
        children: children
      }), animated && (0, jsx_runtime_1.jsx)(A, {
        href: to,
        onClick: scrollToSection,
        children: children
      })]
    }) : null
  });
};

exports.Link = Link;